export const NomenclatureType = {
  SEMI_FINISHED: 0,
  DISH: 1,
  RAW_MATERIAL: 2,
  GOODS: 3,
  PACKAGING: 4,
  SERVICE: 5,
  OTHER_MATERIAL: 6,
} as const;

export const UnitsType = {
  NONE: 0,
  PIECE: 1,
  GRAM: 2,
  KG: 3,
  ML: 4,
  L: 5,
} as const;

export const VatType = {
  WITHOUT: -1,
} as const;

export const WarehouseIncomeType = {
  MANUAL: 0,
  SUPPLY: 1,
  RECEIPT: 2,
  INVENTORY: 3,
  PRODUCTION: 4,
  TRANSFER: 5,
} as const;

export const WarehouseDocStatus = {
  DRAFT: 0,
  IN_PROGRESS: 5,
  COMPLETED: 10,
  CANCELLED: 15,
} as const;

// Deprecated
// TODO Remove after migration to dictionaries
// Start of deprecated const list
export const NOMENCLATURE_TYPE_SEMI_FINISHED = NomenclatureType.SEMI_FINISHED;
export const NOMENCLATURE_TYPE_DISH = NomenclatureType.DISH;
export const NOMENCLATURE_TYPE_RAW_MATERIAL = NomenclatureType.RAW_MATERIAL;
export const NOMENCLATURE_TYPE_GOODS = NomenclatureType.GOODS;
export const NOMENCLATURE_TYPE_PACKAGING = NomenclatureType.PACKAGING;
export const NOMENCLATURE_TYPE_SERVICE = NomenclatureType.SERVICE;
export const NOMENCLATURE_TYPE_OTHER_MATERIAL = NomenclatureType.OTHER_MATERIAL;

export const VAT_WITHOUT = VatType.WITHOUT;

export const UNITS_TYPE_NONE = UnitsType.NONE;
export const UNITS_TYPE_PIECE = UnitsType.PIECE;
export const UNITS_TYPE_GRAM = UnitsType.GRAM;
export const UNITS_TYPE_KG = UnitsType.KG;
export const UNITS_TYPE_ML = UnitsType.ML;
export const UNITS_TYPE_L = UnitsType.L;
// ========== End of deprecated const list ========

export const UNIT_COEFFICIENTS: Record<number, number> = {
  [UnitsType.PIECE]: 1,
  [UnitsType.GRAM]: 1,
  [UnitsType.KG]: 1000,
  [UnitsType.ML]: 1,
  [UnitsType.L]: 1000,
};

export const ALLOWED_UNIT_CONVERSIONS: Record<number, number[]> = {
  [UnitsType.PIECE]: [UnitsType.GRAM, UnitsType.KG],
  [UnitsType.GRAM]: [UnitsType.KG, UnitsType.L],
  [UnitsType.KG]: [UnitsType.GRAM],
  [UnitsType.ML]: [UnitsType.L, UnitsType.GRAM],
  [UnitsType.L]: [UnitsType.ML, UnitsType.GRAM],
};

export const DEFAULT_INCOME_TYPE = WarehouseIncomeType.MANUAL;

export const INCOME_SEARCH_PARAMS = {
  SUPPLIER_ID: 'supplierId',
  WAREHOUSE_ID: 'warehouseId',
  TYPE: 'type',
  STATUS: 'status',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
} as const;
